import React, { useState, useEffect } from 'react';
import { useRoutes, useLocation, useNavigate } from 'react-router-dom';
import router from 'src/router';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import './index.css';
import {
  getCookie,
  setLocalStorage,
  getAuthenticated
} from 'src/common/config/FunctionHelper';
import { COOKIE_NAME } from './appConfig';

function App() {
  const content = useRoutes(router);
  // Check user logged or not

  let location = useLocation();
  React.useEffect(() => {
    // Google Analytics
    if (location) {
      if (
        location.pathname === '/dashboards' ||
        location.pathname === '/settings'
      ) {
        // widget Show
        setTimeout(function () {
          if (document.querySelector('.circle-widget-trigger')) {
            const widget: any = document.querySelector(
              '.circle-widget-trigger'
            );
            widget.style.display = 'inherit';
          }
        }, 1000);
      } else {
        // widget hide
        setTimeout(function () {
          if (document.querySelector('.circle-widget-trigger')) {
            const widget: any = document.querySelector(
              '.circle-widget-trigger'
            );
            widget.style.display = 'none';
          }
        }, 1000);
      }
      // Set cookie
      if (getCookie(COOKIE_NAME) != 'false') {
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('userName', getCookie('userName'));
      } else {
        if (getCookie(COOKIE_NAME) == 'false') {
          localStorage.setItem('isAuthenticated', 'false');
          localStorage.setItem('userName', '');
          return;
        }
        if (getCookie(COOKIE_NAME) != 'false') {
          localStorage.setItem('isAuthenticated', 'true');
          localStorage.setItem('userName', getCookie('userName'));
        }
      }
    }
  }, [location]);
  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        {content}
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
